import React, { Component } from 'react'
import { Tooltip } from 'reactstrap'

class PillTip extends Component {

  state = {
    isTooltip: false,
    colors: [ "primary", "success", "danger", "warning", "info" ]
  }

  togglePill = () => {
    const toggleState = !this.state.isTooltip
    this.setState({
      isTooltip: toggleState
    })
  }

  render () {
    return (
      <Tooltip placement="right" isOpen={this.state.isTooltip} target={this.props.target} toggle={this.togglePill}>
        {this.props.message}
      </Tooltip>
    )
  }
}

export default PillTip
